export const fetchDrivers = async (apiKey) => {
  try {
    // Use count parameter to increase the number of results returned in a single call
    const response = await fetch("https://api.simracing.co.uk/v0.1/customers?count=1000", {
      headers: { Authorization: `SRL ${apiKey}` },
    });

    if (response.status === 429) {
      throw new Error("Database overwhelmed");
    }

    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "text/xml");

    const drivers = Array.from(xmlDoc.getElementsByTagName("customer")).map((customer) => ({
      id: customer.getElementsByTagName("id")[0].textContent,
      name: customer.getElementsByTagName("name")[0].textContent,
      homeVenue: customer.getElementsByTagName("home_venue")[0].textContent,
      driverClass: customer.getElementsByTagName("class")[0].textContent,
      lapsRecorded: customer.getElementsByTagName("laps_recorded")[0]?.textContent || "N/A",
      lastVehicle: customer.getElementsByTagName("last_vehicle")[0]?.textContent || "N/A",
      lastCircuit: customer.getElementsByTagName("last_circuit")[0]?.textContent || "N/A",
      points: 0,
    }));

    return { data: drivers, error: null };
  } catch (error) {
    console.error("Error fetching drivers:", error);
    return { data: null, error: error.message };
  }
};
